import { IWorkerGlobalStatus } from './types';

export const convertStatsToNumber = (
  obj: IWorkerGlobalStatus<string>,
): IWorkerGlobalStatus<number> => {
  const res: Record<string, unknown> = {};

  Object.keys(obj).forEach((key: string) => {
    res[key] = {};

    const value: unknown = obj[key as keyof IWorkerGlobalStatus];

    if (typeof value === 'object') {
      // Nested stat buckets share the same string-to-number shape, so the
      // conversion recurses into them with the known container type.
      res[key] = convertStatsToNumber(value as IWorkerGlobalStatus<string>);
    } else if (typeof value === 'string') {
      try {
        const parsed = parseInt(value, 10);

        res[key] = Number.isNaN(parsed) ? value : parsed;
      } catch (_error) {
        res[key] = value;
      }
    } else {
      res[key] = value;
    }
  });

  return res as unknown as IWorkerGlobalStatus<number>;
};
